import { render, staticRenderFns } from "./elem-label.vue?vue&type=template&id=32e5455b&"
import script from "./elem-label.vue?vue&type=script&lang=js&"
export * from "./elem-label.vue?vue&type=script&lang=js&"
import style0 from "./elem-label.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports